/**
 * Type of action which sets the current state of noise suppression.
 *
 * {
 *     type: SET_FACE_RECOGNITION_ENABLED,
 *     enabled: boolean
 * }.
 */
export const SET_PICTURE_IN_PICTURE_ENABLED = 'SET_PICTURE_IN_PICTURE_ENABLED';
export const SET_PICTURE_IN_PICTURE_OBJECT = 'SET_PICTURE_IN_PICTURE_OBJECT';
